import {Footer} from "../components/Footer";
import Navbar from "../components/nav/Navbar";
import {Link} from "react-router";
import {Button} from "@mui/material";
import { PinDrop } from "@mui/icons-material";
import "./home.css";

export function Home() {
    return <div id="app-root">
        <Navbar />
        <div className="row home">
            <div className="col-md-6">
                <h1>Your<br />Travel<br />Map</h1>
            </div>
            <div className="col-md-6">
                <p>Keep track of your <strong>wayfare</strong> throughout the world.</p>
                <p>
                    <small>Share your map with others or keep it as a personal logbook.</small>
                </p>
                <Link to="/my-wayfare">
                    <Button variant="contained" color="primary" size="large" startIcon={<PinDrop />}>Create My Wayfare &raquo;</Button>
                </Link>
            </div>
        </div>
        <Footer />
    </div>
}
